const t = { last_updated: "Última atualização", Series_type: "Série", "How to guide_type": "Guia", FAQ_type: "Predefinido" }, e = {
  articles: t
};
export {
  t as articles,
  e as default
};
//# sourceMappingURL=help-center-knowledge-anatomies35.js.map
